import(/* webpackMode: "eager", webpackExports: ["FaqSection"] */ "/vercel/path0/src/components/sections/faq-section.tsx");
